import React from 'react'
import TagsFilter from './TagsFilter'
import { toggleSelection } from '../utils/helpers'
import { translations, rarityLabels, statusLabels } from '../data/translations'

const LocationFilters = ({
  filtersOpen,
  setFiltersOpen,
  selectedRarities,
  setSelectedRarities,
  selectedStatuses,
  setSelectedStatuses,
  language,
}) => {
  const t = translations[language]

  return (
    <div className="filters">
      <button
        className="filters__toggle"
        onClick={() => setFiltersOpen(!filtersOpen)}
      >
        <span className="filters__toggle-text">{t.filters.filtersTitle}</span>
        <div className={`filters__toggle-icon ${filtersOpen ? 'open' : ''}`} />
      </button>
      <div className={`filters__content ${filtersOpen ? 'active' : ''}`}>
        <div className="filters__wrapper">
          <TagsFilter
            title={t.filters.tags}
            tags={[
              'common',
              'uncommon',
              'rare',
              'ultra-rare',
              'released',
              'unreleased',
            ]}
            selected={[...selectedRarities, ...selectedStatuses]}
            onToggle={(tag) => {
              const rarityTags = ['common', 'uncommon', 'rare', 'ultra-rare']
              if (rarityTags.includes(tag)) {
                toggleSelection(selectedRarities, tag, setSelectedRarities)
              } else {
                toggleSelection(selectedStatuses, tag, setSelectedStatuses)
              }
            }}
            language={language}
            rarityLabels={rarityLabels}
            statusLabels={statusLabels}
          />
        </div>
      </div>
    </div>
  )
}

export default LocationFilters
